import React from 'react';
import Select from 'react-select';

const PlanModal = ({ isOpen, setIsOpen }) => {
    if (!isOpen) return null;

    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
    ];

    const branchOptions = [
        { value: 'branch1', label: 'Branch 1' },
        { value: 'branch2', label: 'Branch 2' },
        // Add more branches as needed
    ];

    const ageGroupOptions = [
        { value: 'kids', label: 'Kids' },
        { value: 'teens', label: 'Teens' },
        { value: 'adults', label: 'Adults' },
    ];

    const categoryLevelOptions = [
        { value: 'beginner', label: 'Beginner' },
        { value: 'intermediate', label: 'Intermediate' },
        { value: 'advanced', label: 'Advanced' },
    ];

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Plan/Package Details</h2>
                <form className="oms-modal-form">
                    <div className="oms-form-flex">
                    <div className="oms-form-group">
                        <label htmlFor="planName" className="oms-form-label">
                            Package/Plan Name
                        </label>
                        <input type="text" id="planName" placeholder="Enter package/plan name" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="branch" className="oms-form-label">
                            Branch Name
                        </label>
                        <Select options={branchOptions} placeholder="Select branch" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="ageGroup" className="oms-form-label">
                            Age Group
                        </label>
                        <Select options={ageGroupOptions} placeholder="Select age group" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="categoryLevel" className="oms-form-label">
                            Category Level
                        </label>
                        <Select options={categoryLevelOptions} placeholder="Select category level" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="basePrice" className="oms-form-label">
                            Base Price
                        </label>
                        <input type="number" id="basePrice" placeholder="Enter base price" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="finalPrice" className="oms-form-label">
                            Final Price
                        </label>
                        <input type="number" id="finalPrice" placeholder="Enter final price" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="features" className="oms-form-label">
                            Features/Benefits
                        </label>
                        <input id="features" placeholder="Enter features/benefits" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="duration" className="oms-form-label">
                            Duration (in months)
                        </label>
                        <input type="number" id="duration" placeholder="Enter duration in months" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select options={statusOptions} placeholder="Select status" />
                    </div>
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PlanModal;
